<template>
    <b-modal
        id="create-period"
        modal-class="apprentice-default-modal create-module-period-modal"
        size="lg"
        :title="$t('modules.add_time_block')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')"
        @ok="storePeriod"
        @show="onShow">
        <div class="create-time-period">
            <div
                class="error"
                v-if="hasError">
                <b-alert
                    show
                    variant="danger">
                    {{ $t('modules.you_did_not_fill_in_all_fields_correctly') }}
                </b-alert>
            </div>

            <div
                class="notice"
                v-else>
                <b-alert
                    show
                    variant="warning">
                    {{ $t('common.all_fields_are_mandatory') }}
                </b-alert>
            </div>

            <div class="name">
                <b-form-group
                    class="group-name"
                    :label="$t('common.name')"
                    label-for="name-input">
                    <b-form-input
                        class="field-name-input"
                        id="name-input"
                        v-model="name"
                        :placeholder="$t('common.name')">
                    </b-form-input>
                </b-form-group>
            </div>

            <div class="day-timestamp">
                <b-form-group
                    class="group-weekday"
                    :label="$t('modules.day')"
                    label-for="weekday-input">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="field-weekday-select"
                        v-model="weekday"
                        :options="weekdays">
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    class="group-time_start"
                    :label="$t('modules.start_time')"
                    label-for="time-start-input">
                    <design-2021-apprentice-timepicker-component
                        id="time-start-input"
                        v-model="time_start">
                    </design-2021-apprentice-timepicker-component>
                </b-form-group>

                <b-form-group
                    class="group-time_end"
                    :label="$t('modules.end_time')"
                    label-for="time-end-input">
                    <design-2021-apprentice-timepicker-component
                        id="time-end-input"
                        v-model="time_end">
                    </design-2021-apprentice-timepicker-component>
                </b-form-group>

                <b-form-group
                    class="group-duration"
                    :label="$t('modules.duration')"
                    label-for="duration-input">
                    <b-form-input
                        class="duration-input"
                        v-model="duration"
                        :placeholder="$t('modules.amount_of_hours')"
                        type="number">
                    </b-form-input>
                </b-form-group>
            </div>

            <div class="subscription-period">
                <b-form-group
                    class="group-period-submission-opening"
                    label-for="period-submission-opening-input"
                    :label="$t('modules.registration_open_from')">
                    <b-form-datepicker
                        class="apprentice-date-picker btn-submission-opening"
                        id="period-submission-opening-input"
                        v-model="submissionOpening"
                        menu-class="datedropdown"
                        start-weekday="1"
                        now-button
                        reset-button
                        right
                        today-variant="primary"
                        nav-button-variant="primary"
                        locale="nl"
                        :aria-controls="$t('modules.choose_a_date')"
                        label-reset-button="reset"
                        :label-no-date-selected="$t('modules.no_date_selected')"
                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }">
                    </b-form-datepicker>
                </b-form-group>
                <b-form-group
                    label="om"
                    label-for="subscription-period-timepicker-input">
                    <design-2021-apprentice-timepicker-component v-model.lazy="submissionOpeningTime">
                    </design-2021-apprentice-timepicker-component>
                </b-form-group>
            </div>

            <div class="date">
                <b-form-group
                    class="group-period-submission-deadline"
                    label-for="period-submission-deadline-input"
                    :label="$t('modules.registration_deadline')">
                    <b-form-datepicker
                        class="apprentice-date-picker btn-submission-deadline"
                        id="period-submission-deadline-input"
                        v-model="submissionDeadline"
                        menu-class="datedropdown"
                        start-weekday="1"
                        now-button
                        reset-button
                        right
                        today-variant="primary"
                        nav-button-variant="primary"
                        locale="nl"
                        :aria-controls="$t('modules.choose_a_date')"
                        label-reset-button="reset"
                        :label-no-date-selected="$t('modules.no_date_selected')"
                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }">
                    </b-form-datepicker>
                </b-form-group>
                <b-form-group
                    label="om"
                    label-for="group-period-submission-deadline-timepicker-input">
                    <design-2021-apprentice-timepicker-component v-model.lazy="submissionDeadlineTime">
                    </design-2021-apprentice-timepicker-component>
                </b-form-group>
            </div>
            <div class="date">
                <b-form-group
                    class="group-period-start-date"
                    label-for="period-start-date-input"
                    :label="$t('modules.start_date')">
                    <b-form-datepicker
                        class="apprentice-date-picker btn-start-date"
                        id="period-start-date-input"
                        v-model="startDate"
                        menu-class="datedropdown"
                        start-weekday="1"
                        now-button
                        reset-button
                        right
                        today-variant="primary"
                        nav-button-variant="primary"
                        locale="nl"
                        :aria-controls="$t('modules.choose_a_date')"
                        label-reset-button="reset"
                        :label-no-date-selected="$t('modules.no_date_selected')"
                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }">
                    </b-form-datepicker>
                </b-form-group>

                <b-form-group
                    class="group-period-end-date"
                    label-for="period-end-date-input"
                    :label="$t('modules.end_date')">
                    <b-form-datepicker
                        class="apprentice-date-picker btn-end-date"
                        id="period-end-date-input"
                        v-model="endDate"
                        menu-class="datedropdown"
                        start-weekday="1"
                        now-button
                        reset-button
                        right
                        today-variant="primary"
                        nav-button-variant="primary"
                        locale="nl"
                        :aria-controls="$t('modules.choose_a_date')"
                        label-reset-button="reset"
                        :label-no-date-selected="$t('modules.end_date')"
                        :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }">
                    </b-form-datepicker>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
import Design2021ApprenticeMultiselectComponent from '../../common/design-2021-apprentice-multiselect-component.vue';
import $ from 'jquery';

export default {
    name: 'design-2021-module-period-create-modal-component',
    components: { Design2021ApprenticeMultiselectComponent },
    props: ['periodsIn'],
    data() {
        return {
            periods: this.periodsIn,
            name: null,
            period: null,
            duration: null,
            weekday: null,
            time_start: null,
            time_end: null,
            submissionOpening: null,
            submissionOpeningTime: '00:00',
            submissionDeadline: null,
            submissionDeadlineTime: '00:00',
            startDate: null,
            endDate: null,
            weekdays: [
                {
                    value: null,
                    text: this.$t('modules.choose_a_day'),
                    disabled: true,
                },
                {
                    value: 1,
                    text: this.$t('modules.monday'),
                },
                {
                    value: 2,
                    text: this.$t('modules.tuesday'),
                },
                {
                    value: 3,
                    text: this.$t('modules.wednesday'),
                },
                {
                    value: 4,
                    text: this.$t('modules.thursday'),
                },
                {
                    value: 5,
                    text: this.$t('modules.friday'),
                },
                {
                    value: 6,
                    text: this.$t('modules.saturday'),
                },
                {
                    value: 7,
                    text: this.$t('modules.sunday'),
                },
            ],
            hasError: true,
        };
    },

    methods: {
        onShow() {
            this.name = null;
            this.period = null;
            this.duration = null;
            this.time_start = null;
            this.time_end = null;
            this.weekday = null;
            this.submissionOpening = null;
            this.submissionOpeningTime = '00:00';
            this.submissionDeadline = null;
            this.submissionDeadlineTime = '00:00';
            this.startDate = null;
            this.endDate = null;
            this.hasError = false;
        },

        storePeriod(bvModalEvent) {
            if (!this.isFormValidated()) {
                this.hasError = true;
                $('.create-module-period-modal').animate({ scrollTop: 0 }, 500);
                bvModalEvent.preventDefault();
                return;
            }

            const weekday = this.weekdays.find((wekday) => wekday.value === this.weekday);
            this.alert.saving();
            let data = {
                name: this.name,
                // period_id: this.period.id,
                duration: this.duration,
                time_start: this.time_start,
                time_end: this.time_end,
                sign_up_from_date: `${this.submissionOpening} ${this.submissionOpeningTime}`,
                sign_up_until_date: `${this.submissionDeadline} ${this.submissionDeadlineTime}`,
                start_date: this.startDate,
                end_date: this.endDate,
                weekday: weekday.text,
            };

            axios
                .post(this.routes.modulePeriods(), data)
                .then((response) => {
                    this.$emit('add-module-period', response.data);
                    this.alert.success();
                })
                .catch(function (error) {
                    this.alert.ajaxError(error);
                });
        },

        isFormValidated() {
            this.hasError = false;
            return (
                this.name !== null &&
                this.name !== '' &&
                // (this.period !== null && this.period !== '') &&
                this.duration !== null &&
                this.duration !== '' &&
                this.weekday !== null &&
                this.weekday !== '' &&
                this.time_start !== null &&
                this.time_start !== '' &&
                this.time_end !== null &&
                this.time_end !== '' &&
                this.submissionDeadline !== null &&
                this.submissionDeadline !== '' &&
                this.submissionDeadlineTime !== null &&
                this.submissionDeadlineTime !== '' &&
                this.submissionOpening !== null &&
                this.submissionOpening !== '' &&
                this.submissionOpeningTime !== null &&
                this.submissionOpeningTime !== '' &&
                this.startDate !== null &&
                this.startDate !== '' &&
                this.endDate !== null &&
                this.endDate !== ''
            );
        },
    },

    watch: {
        period: function (newVal) {
            this.period = newVal;
        },
    },
};
</script>

<style scoped lang="scss">
.form-control,
select,
input,
.form-group,
::v-deep .apprentice-default-time-picker input {
    margin-bottom: 0;
}

.name,
.day-timestamp,
.subscription-period {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.name,
.day-timestamp,
.subscription-period,
.date {
    > .form-group {
        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .name,
    .day-timestamp,
    .subscription-period {
        margin-bottom: $grid-gutter-width;
    }

    .date {
        margin-bottom: 9px;
    }

    .name,
    .day-timestamp,
    .subscription-period,
    .date {
        > .form-group {
            &:not(:last-child) {
                margin-bottom: 0;
            }
        }
    }

    .day-timestamp,
    .subscription-period,
    .date {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');
    }

    .day-timestamp {
        > .form-group {
            flex: 0 1 calc(25% - 15px);
        }
    }

    .subscription-period,
    .date {
        > .form-group {
            flex: 0 1 calc(50% - 15px);
        }
    }
}
</style>
